// routes/FrontendRoutes.js

import React from 'react';
import { Route } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import BusinessSegments from '../components/Frontend/AccountDetails/BusinessSegments/BusinessSegments';

export const businessSegmentsRoute = (
  <>
    <Route path="/business_segments" element={<MainLayout />}>
      <Route index element={<BusinessSegments />} />
    </Route>
  </>
);
